import styled from 'styled-components';
import Button from '../Button';
import { fontWeight, space, declaration, pressed } from '../../style/utils';

const WidgetButton = styled(Button)`
  font-weight: ${fontWeight('regular')};
  line-height: normal;
  gap: ${space('xs')};

  ${({ theme }) => {
    const colors = theme.tokens.components.widgetButton;
    return `
      background: ${colors.bg};
      color: ${colors.fg};
      ${declaration('border', colors.border)}

      :hover {
        background: ${colors.hoverBg};
        color: ${colors.hoverFg};
      }

      ${pressed(colors.pressedBg)}

      :disabled {
        background: ${colors.disabledBg};
        ${declaration('color', colors.disabledFg)}

        svg > path {
          ${declaration('fill', colors.disabledIcon)}
        }
      }
    `;
  }}

  .MuiButton-startIcon,
  .MuiButton-endIcon {
    margin: unset;
  }

  :disabled {
    cursor: not-allowed;

    svg {
      opacity: 0.3;
    }
  }
`;

WidgetButton.defaultProps = {
  ...WidgetButton.defaultProps,
  size: 'extraSmall',
};

export default WidgetButton;
